// Message colours as inline styles. The app ships a prebuilt Tailwind file
// (src/css/tailwind.compiled.css) that is not regenerated by `npm start`, and it
// has no translucent status backgrounds or red/yellow 200 text, so the utility
// classes for these silently render as unstyled text.
export const tones = {
  ok: { backgroundColor: "rgba(20, 83, 45, 0.9)", color: "#bbf7d0" },
  error: { backgroundColor: "rgba(127, 29, 29, 0.9)", color: "#fecaca" },
  warning: { backgroundColor: "rgba(113, 63, 18, 0.9)", color: "#fef08a" },
};

export default tones;
